import { render, staticRenderFns } from "./OtherInfo.vue?vue&type=template&id=7d9879ac&scoped=true"
import script from "./OtherInfo.vue?vue&type=script&lang=js"
export * from "./OtherInfo.vue?vue&type=script&lang=js"
import style0 from "./OtherInfo.vue?vue&type=style&index=0&id=7d9879ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9879ac",
  null
  
)

export default component.exports